import iconUrl from '../assets/clash-icon.svg';

/**
 * Standalone preview of the "Clash" X app icon. Reachable at /dev/icon (no auth)
 * so the mark can be eyeballed at every size and screenshotted at 1080×1080.
 */
const SIZES = [240, 120, 88, 60, 40] as const;

function Squircle({ size, radius }: { size: number; radius?: number }) {
  return (
    <img
      src={iconUrl}
      width={size}
      height={size}
      alt="HeadToHead Clash icon"
      style={{ borderRadius: radius ?? Math.round(size * 0.225) }}
      className="shadow-[0_24px_48px_-20px_rgba(0,0,0,0.55)]"
    />
  );
}

export default function IconShowcase() {
  return (
    <div className="min-h-full w-full overflow-y-auto bg-[#F4F4F6] px-6 py-12 text-[#15171C]">
      <div className="mx-auto flex w-full max-w-[640px] flex-col gap-10">
        <header className="flex items-center gap-5">
          <Squircle size={96} />
          <div>
            <p className="text-[11px] font-bold uppercase tracking-[0.18em] text-[#9A9AA4]">
              App icon · 02
            </p>
            <h1 className="text-[34px] font-extrabold leading-none tracking-tight">Clash</h1>
            <p className="mt-2 max-w-[420px] text-[14px] leading-[1.5] text-[#5B5E66]">
              Two chevrons charging inward — pure momentum, and at a glance a confident ×. The
              most energetic, sportiest mark; the two halves spring apart and snap together.
            </p>
          </div>
        </header>

        {/* Hero capture frame — this is what gets exported at 1080×1080 */}
        <section className="rounded-[28px] border border-black/5 bg-white p-8 shadow-[0_30px_70px_-40px_rgba(0,0,0,0.45)]">
          <div className="flex flex-col items-center gap-6">
            <Squircle size={240} radius={54} />
            <span className="rounded-full bg-[#10A24F]/10 px-3 py-1 text-[12px] font-bold text-[#0E8C44]">
              most energetic
            </span>
          </div>
        </section>

        {/* Size ladder */}
        <section className="rounded-[28px] border border-black/5 bg-white p-8 shadow-[0_30px_70px_-40px_rgba(0,0,0,0.45)]">
          <p className="mb-6 text-[11px] font-bold uppercase tracking-[0.16em] text-[#9A9AA4]">
            Renders clean at every size
          </p>
          <div className="flex flex-wrap items-end gap-6">
            {SIZES.map((s) => (
              <div key={s} className="flex flex-col items-center gap-2">
                <Squircle size={s} />
                <span className="text-[11px] font-semibold text-[#9A9AA4]">{s}px</span>
              </div>
            ))}
          </div>
        </section>

        {/* On-device backdrops */}
        <section className="grid grid-cols-2 gap-4">
          <div className="flex items-center justify-center rounded-[24px] bg-[#0E1014] p-10">
            <Squircle size={120} />
          </div>
          <div className="flex items-center justify-center rounded-[24px] bg-gradient-to-br from-[#E9ECF2] to-[#C7CCD6] p-10">
            <Squircle size={120} />
          </div>
        </section>
      </div>
    </div>
  );
}
